import './index.css'
import Button from '../button'
import confetti from 'canvas-confetti';
import { useState,useRef } from 'react';

function TestEnvironment(){
   const inputRef = useRef();
    const [enteredCompetitor,SetEnteredCompetitor] = useState("competitor.xyz");

    const nextSlide = () => {

    }
    const navigateToSignupPage = () => {
        window.location.href = '/signup';
    }
    const moveToFeedItem = () => {
      document.getElementById("one").remove();
      document.getElementById("two").style.display = "block";
      const el = document.getElementById("text-environment-changing");
      const value = inputRef.current?.value;
      if (value) {
         SetEnteredCompetitor(value);
       }
      const y = el.getBoundingClientRect().top + window.pageYOffset - 50;

      window.scrollTo({
        top: y,
        behavior: "smooth"
      });    
    };
    
    const moveToIdeaItem = () => {
      document.getElementById("two").remove();
      document.getElementById("three").style.display = "block";
      const el = document.getElementById("text-environment-changing");
      const y = el.getBoundingClientRect().top + window.pageYOffset - 50;

      window.scrollTo({
        top: y,
        behavior: "smooth"
      });    
    }
    const moveToStructuredIdea = () => {
      document.getElementById("three").remove();
      document.getElementById("four").style.display = "block";
      const el = document.getElementById("text-environment-changing");
      const y = el.getBoundingClientRect().top + window.pageYOffset - 50;

      window.scrollTo({
        top: y,
        behavior: "smooth"
      });    

    }
    const moveToScheduleItem = () => {
      document.getElementById("four").remove();
      document.getElementById("five").style.display = "block";
      const el = document.getElementById("text-environment-changing");
      const y = el.getBoundingClientRect().top + window.pageYOffset - 50;
      Array.from(document.getElementsByClassName("schedule-item")).forEach(element => {
        element.addEventListener("click", function(event) {
          console.log(event.target.classList);
          let tagIt;
          if(event.target.classList.contains("date-number")){
            tagIt = event.target.parentElement
          }
          else{
            tagIt = event.target
          }
          Array.from(document.getElementsByClassName("schedule-item")).forEach(element => {
            element.classList.remove("selected-date")
          })
          tagIt.classList.add("selected-date");
        });
      });

      window.scrollTo({
        top: y,
        behavior: "smooth"
      });    
    }
    const congrats = () => {
      document.getElementById("five").remove();
      confetti({
        particleCount: 100,
        spread: 70,
        origin: { y: 0.6 },
      });
      document.getElementById("six").style.display = "flex";
      const el = document.getElementById("text-environment-changing");
      const y = el.getBoundingClientRect().top + window.pageYOffset - 50;

      window.scrollTo({
        top: y,
        behavior: "smooth"
      });    
    }
    return (
        <div className="test-environment">
          <h2 className="big-text">How does Mako work?</h2>
          <p className="small-text" id="description-of-work">Simply add a website and Mako will create a social media style feed of all posts on that website. You can then use AI to create and structure blog and social post ideas from this feed.</p>
          <div id='text-environment-changing'>
          <div id='one'>
          <div id="add-module">
            <div className="input-module-title-holder">
              <h2 className="big-text">Add an input</h2>
            </div>      
            <div className="small-text">
              Enter a domain of a website. Mako will then crawl the website for new posts and alert you when they post new content.
            </div>
      
            <div>
              <div className="small-text label">Domain name</div>
              <input
                id="url-input-field"
                className="small-text"
                type="url"
                placeholder=""
                ref={inputRef}
              />
            </div>
      
            <div className="button-holder">
              <div className="button small-text" onClick={moveToFeedItem}>
                <div className="button-contents">
                  Add input
                </div>
              </div>
            </div>

          </div>
          </div>
          <div id='two'>
          <div className="feed-item new-post">
      <div className="date-and-tag-holder tiny-text">
         <img className="feed-logo" src="./images/live-demo/logo.png"></img>
         <div className="feed-tag">
            <div className="new-content-globule" ></div>
            <div>Wed Apr 02 2025</div>
         </div>
      </div>
      <img src="./images/live-demo/meta-image.png"></img>
      <h2 className="medium-text">Why I Am Perfect And All My Competitors Suck</h2>
      <div className="text-holder">
            <p className="url tiny-text">{enteredCompetitor}/why-im-great</p>
         <p className="tiny-text overview-excerpt">A breakdown of why we are the greatest company to ever exist, and no one ever compares to our greatness.</p>
      </div>
      <div className="action-bar">
         <div className="button tiny-text" onClick={moveToIdeaItem}>
            <div className="button-contents">
               <div>Generate blog</div>
            </div>
         </div>
      </div>
          </div>
          </div>
          <div id='three'>
          <div class="idea-item idea">
              <div class="idea-info-holder">
                <div class="tiny-text date">Fri Mar 21 2025</div>
                <div class="tiny-text">Blog idea</div>
              </div>
              <div class="idea-title-holder">
                <h2>Why You Shouldn’t Compare</h2>
              </div>
              <div class="info-holder">
                <div class="generated-from-holder tiny-text">
                    <div class="label">Generated from</div>
                    <div class="value">Why I Am Perfect And All My Competitors Suck</div>
                </div>
                <div class="status-holder tiny-text">
                    <div class="label">Status</div>
                    <div class="status-graph-holder">
                      <div class="status-widget complete"></div>
                      <div class="status-widget"></div>
                      <div class="status-widget"></div>
                    </div>
                    <div class="value">Not started yet</div>
                </div>
              </div>
                <div class="button tiny-text" onClick={moveToStructuredIdea}>
                    <div class="button-contents" >
                      <div>Structure content with AI</div>
                    </div>
                </div>
          </div>
          </div>
          <div id="four">
          <div class="expanded-idea" >
   <div class="expanded-idea-header">
      <h1 class="big-text">Why You Shouldn't Compare</h1>
   </div>
   <div class="info-holder-expanded">
      <div class="export-holder">
         <div class="button small-text">
            
            <div onClick={moveToScheduleItem}class="button-contents" >
               <img src="./images/schedule.png" ></img>
               <div>Schedule</div>
            </div>
         </div>
      </div>
   </div>
   <p id="idea-content">A breakdown of why comparison is the thief of joy and why brands like XYZ shouldn't engage in petty mudslinging.</p>
</div>
          </div>
          <div id='five'>
          <div id="idea-scheduler">
   <div class="idea-schedule-header">
      <h2 class="idea-schedule-month">April 2025</h2>
   </div>
   <div>
      <div class="days-header mini-header tiny-text">
         <div class="day-item">Mon</div>
         <div class="day-item">Tue</div>
         <div class="day-item">Wed</div>
         <div class="day-item">Thu</div>
         <div class="day-item">Fri</div>
         <div class="day-item">Sat</div>
         <div class="day-item">Sun</div>
      </div>
      <div class="schedule-container mini-picker">
         <div class="empty-item"></div>
         <div class="schedule-item mini-date small-text">
            <div class="date-number" >1</div>
         </div>
         <div class="schedule-item mini-date small-text">
            <div class="date-number" >2</div>

         </div>
         <div class="schedule-item mini-date small-text is-today">
            <div class="date-number" >3</div>
         </div>
         <div class="schedule-item mini-date small-text">
            <div class="date-number" >4</div>
         </div>
         <div class="schedule-item mini-date small-text">
            <div class="date-number" >5</div>
         </div>
         <div class="schedule-item mini-date small-text">
            <div class="date-number" >6</div>
         </div>
         <div class="schedule-item mini-date small-text">
            <div class="date-number" >7</div>
         </div>
         <div class="schedule-item mini-date small-text">
            <div class="date-number" >8</div>
         </div>
         <div class="schedule-item mini-date small-text">
            <div class="date-number" >9</div>
         </div>
         <div class="schedule-item mini-date small-text">
            <div class="date-number" >10</div>
         </div>
         <div class="schedule-item mini-date small-text">
            <div class="date-number" >11</div>
         </div>
         <div class="schedule-item mini-date small-text">
            <div class="date-number" >12</div>
         </div>
         <div class="schedule-item mini-date small-text">
            <div class="date-number" >13</div>
         </div>
         <div class="schedule-item mini-date small-text">
            <div class="date-number" >14</div>
         </div>
         <div class="schedule-item mini-date small-text">
            <div class="date-number" >15</div>
         </div>
         <div class="schedule-item mini-date small-text">
            <div class="date-number" >16</div>
         </div>
         <div class="schedule-item mini-date small-text">
            <div class="date-number" >17</div>
         </div>
         <div class="schedule-item mini-date small-text">
            <div class="date-number" >18</div>
         </div>
         <div class="schedule-item mini-date small-text">
            <div class="date-number" >19</div>
         </div>
         <div class="schedule-item mini-date small-text">
            <div class="date-number" >20</div>
         </div>
         <div class="schedule-item mini-date small-text">
            <div class="date-number" >21</div>
         </div>
         <div class="schedule-item mini-date small-text">
            <div class="date-number" >22</div>
         </div>
         <div class="schedule-item mini-date small-text">
            <div class="date-number" >23</div>
         </div>
         <div class="schedule-item mini-date small-text">
            <div class="date-number" >24</div>
         </div>
         <div class="schedule-item mini-date small-text">
            <div class="date-number" >25</div>
         </div>
         <div class="schedule-item mini-date small-text">
            <div class="date-number" >26</div>
         </div>
         <div class="schedule-item mini-date small-text">
            <div class="date-number" >27</div>
         </div>
         <div class="schedule-item mini-date small-text">
            <div class="date-number" >28</div>
         </div>
         <div class="schedule-item mini-date small-text">
            <div class="date-number" >29</div>
         </div>
         <div class="schedule-item mini-date small-text">
            <div class="date-number" >30</div>
         </div>
      </div>
   </div>
   <div>
      <div class="button small-text" onClick={congrats}>
         <div class="button-contents">
            <div>Schedule post</div>
         </div>
      </div>
   </div>
          </div>
          </div>
          <div id='six'>
              <h2>And that's how it works!</h2>
              <p>Want to try it out for 7 days free?</p>
              <div class="button small-text" onClick={navigateToSignupPage}>
              <div class="button-contents">
                  <div>Start free trial!</div>
              </div>
            </div>
          </div>
          </div>
        </div>
      );
}

export default TestEnvironment